(function () {
  // Guard against the script being included once per section instance
  if (window.CardCarousel) return;

  var DRAG_THRESHOLD = 5;
  var EDGE_TOLERANCE = 2;

  function CardCarousel(root) {
    this.root = root;
    this.track = root.querySelector('.js-card-carousel-track');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.js-card-carousel-slide'));
    this.header = root.querySelector('.js-card-carousel-header');
    this.nav = root.querySelector('.js-card-carousel-nav');
    this.prev = root.querySelector('.js-card-carousel-prev');
    this.next = root.querySelector('.js-card-carousel-next');
    this.status = root.querySelector('.js-card-carousel-status');
    this.hasIntro = !!root.querySelector('.card-carousel__intro');

    this.userInteracted = false;
    this.suppressClick = false;
    this.drag = null;
    this.scrollFrame = null;
    this.announceTimer = null;

    if (!this.track || !this.slides.length) return;

    this.bindNav();
    this.bindKeyboard();
    this.bindDrag();
    this.bindScroll();
    this.bindResize();
    this.update();
  }

  CardCarousel.prototype.getMaxScroll = function () {
    return Math.max(0, this.track.scrollWidth - this.track.clientWidth);
  };

  CardCarousel.prototype.hasOverflow = function () {
    return this.getMaxScroll() > EDGE_TOLERANCE;
  };

  CardCarousel.prototype.getStep = function () {
    var first = this.slides[0];
    var second = this.slides[1];

    if (second) return second.offsetLeft - first.offsetLeft;
    return first.offsetWidth;
  };

  CardCarousel.prototype.getCurrentIndex = function () {
    var step = this.getStep();
    if (!step) return 0;
    return Math.round(this.track.scrollLeft / step);
  };

  CardCarousel.prototype.goToIndex = function (index) {
    var step = this.getStep();
    var lastIndex = this.slides.length - 1;
    var target = Math.max(0, Math.min(index, lastIndex));

    this.track.scrollTo({ left: Math.min(target * step, this.getMaxScroll()) });
  };

  CardCarousel.prototype.go = function (direction) {
    this.userInteracted = true;

    if (direction > 0 && this.isAtEnd()) return;
    if (direction < 0 && this.isAtStart()) return;

    this.goToIndex(this.getCurrentIndex() + direction);
  };

  CardCarousel.prototype.isAtStart = function () {
    return this.track.scrollLeft <= EDGE_TOLERANCE;
  };

  CardCarousel.prototype.isAtEnd = function () {
    return this.track.scrollLeft >= this.getMaxScroll() - EDGE_TOLERANCE;
  };

  CardCarousel.prototype.update = function () {
    var overflow = this.hasOverflow();

    if (this.nav) this.nav.hidden = !overflow;
    if (this.header) this.header.hidden = !this.hasIntro && !overflow;
    if (this.prev) this.prev.disabled = !overflow || this.isAtStart();
    if (this.next) this.next.disabled = !overflow || this.isAtEnd();

    this.track.classList.toggle('is-draggable', overflow);
  };

  CardCarousel.prototype.getVisibleRange = function () {
    var trackRect = this.track.getBoundingClientRect();
    var first = -1;
    var last = -1;

    this.slides.forEach(function (slide, index) {
      var rect = slide.getBoundingClientRect();
      var inView = rect.left >= trackRect.left - EDGE_TOLERANCE && rect.right <= trackRect.right + EDGE_TOLERANCE;

      if (!inView) return;
      if (first < 0) first = index;
      last = index;
    });

    if (first < 0) {
      first = this.getCurrentIndex();
      last = first;
    }

    return { first: first + 1, last: last + 1 };
  };

  CardCarousel.prototype.announce = function () {
    if (!this.status || !this.userInteracted) return;

    var range = this.getVisibleRange();
    var total = this.slides.length;

    this.status.textContent =
      range.first === range.last
        ? 'Showing card ' + range.first + ' of ' + total
        : 'Showing cards ' + range.first + ' to ' + range.last + ' of ' + total;
  };

  CardCarousel.prototype.bindNav = function () {
    var self = this;

    if (this.prev) {
      this.prev.addEventListener('click', function () {
        self.go(-1);
      });
    }

    if (this.next) {
      this.next.addEventListener('click', function () {
        self.go(1);
      });
    }
  };

  CardCarousel.prototype.bindKeyboard = function () {
    var self = this;

    this.root.addEventListener('keydown', function (event) {
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        self.go(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        self.go(1);
      }
    });
  };

  CardCarousel.prototype.bindDrag = function () {
    var self = this;
    var track = this.track;

    // Links and images are natively draggable, which would hijack the mouse drag
    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || !self.hasOverflow()) return;

      self.drag = {
        pointerId: event.pointerId,
        startX: event.clientX,
        startScroll: track.scrollLeft,
        active: false,
      };
    });

    track.addEventListener('pointermove', function (event) {
      var drag = self.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;

      var deltaX = event.clientX - drag.startX;

      if (!drag.active) {
        if (Math.abs(deltaX) < DRAG_THRESHOLD) return;

        // Only capture once it's a real drag, so plain clicks still reach the card links
        drag.active = true;
        self.userInteracted = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(drag.pointerId);
        if (window.getSelection) window.getSelection().removeAllRanges();
      }

      event.preventDefault();
      track.scrollLeft = drag.startScroll - deltaX;
    });

    function endDrag(event) {
      var drag = self.drag;
      if (!drag || event.pointerId !== drag.pointerId) return;

      self.drag = null;
      if (!drag.active) return;

      self.suppressClick = true;
      window.setTimeout(function () {
        self.suppressClick = false;
      }, 0);

      if (track.hasPointerCapture(drag.pointerId)) {
        track.releasePointerCapture(drag.pointerId);
      }

      track.classList.remove('is-dragging');

      // Snap is disabled while dragging, so settle on the nearest card ourselves
      if (!self.isAtEnd()) {
        self.goToIndex(self.getCurrentIndex());
      }
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    track.addEventListener(
      'click',
      function (event) {
        if (!self.suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        self.suppressClick = false;
      },
      true
    );
  };

  CardCarousel.prototype.bindScroll = function () {
    var self = this;

    this.track.addEventListener(
      'scroll',
      function () {
        if (self.scrollFrame) return;

        self.scrollFrame = window.requestAnimationFrame(function () {
          self.scrollFrame = null;
          self.update();
        });

        window.clearTimeout(self.announceTimer);
        self.announceTimer = window.setTimeout(function () {
          self.announce();
        }, 200);
      },
      { passive: true }
    );

    // Touch swipes count as interaction for screen reader announcements
    this.track.addEventListener(
      'touchstart',
      function () {
        self.userInteracted = true;
      },
      { passive: true }
    );
  };

  CardCarousel.prototype.bindResize = function () {
    var self = this;
    var onResize = function () {
      self.update();
    };

    if ('ResizeObserver' in window) {
      new ResizeObserver(onResize).observe(this.track);
    } else {
      window.addEventListener('resize', onResize);
    }

    // Lazy images can change slide heights but not widths; recheck once everything has loaded
    window.addEventListener('load', onResize);
  };

  CardCarousel.prototype.showSlide = function (slide) {
    var index = this.slides.indexOf(slide);
    if (index >= 0) this.goToIndex(index);
  };

  function initCardCarousel(root) {
    if (!root || root.dataset.cardCarouselInit === 'true') return;
    root.dataset.cardCarouselInit = 'true';
    root.cardCarousel = new CardCarousel(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('.js-card-carousel').forEach(initCardCarousel);
  }

  window.CardCarousel = CardCarousel;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  // Theme editor: bring the selected card into view
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target.closest('.js-card-carousel');
    if (!root || !root.cardCarousel) return;
    root.cardCarousel.showSlide(event.target);
  });
})();
